import styled from 'styled-components'

export const TransactionModalContainer = styled.div`
  box-sizing: border-box;
  padding: 35px 0px;
`
export const TransactionModalSubContainer = styled.div`
  margin-top: 4rem;
  margin-bottom: 2rem;
`
export const TransactionLabel = styled.span`
  font-weight: bold;
`
export const TransactionText = styled.p`
  margin: 0;
  margin-left: 10px;
`
export const ModalTemplateSubTitle = styled.h1`
	color: ${({ theme }) => theme.colors.primary};
  font-family: 'Work Sans';
  font-size: 18px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 25px;
`
export const TransactionModalLoadingContainer = styled.div`
  display: 'flex';
  height: 340px;
  justify-content: 'center';
  align-items: 'center';
`
